import classNames from 'classnames';
import { Delta } from 'quill/core';
import React from 'react';
import deltaToText from '../editor/utils/deltaToText';
import { gql } from '../graphql/generated/gql';
import type { DocumentType } from '../graphql/generated/gql';
import memberAddIcon from '../icons/non-prefilled/16x16/memberAdd.svg';
import userPath from '../utils/url/userPath';
import Avatar, { getAvatarColorSequence } from './Avatar';
import SVGIcon from './SVGIcon';
import SquarishCardBase from './SquarishCardBase';
import Tag from './Tag';
import Timestamp from './Timestamp';
import * as styles from './UserSquarishCard.module.scss';

const USER_FRAGMENT = gql(`
  fragment UserSquarishCard_user on User {
    id
    name
    title
    description
    insertedAt
    
    ...Avatar_user
    ...userPath_user
  }
`);

interface UserSquarishCardProps {
  user: DocumentType<typeof USER_FRAGMENT>;
  link?: boolean;
  badge?: React.ReactNode;
  overflowMenuItems?: React.ReactNode;
}

const UserSquarishCard = ({
  user,
  link,
  overflowMenuItems,
  badge,
}: UserSquarishCardProps) => {
  return (
    <SquarishCardBase
      banner={
        <div
          className={classNames(
            styles.banner,
            styles[`color${getAvatarColorSequence(user.name)}`],
          )}
        >
          <div className={styles.avatar}>
            <Avatar user={user} size={48} />
            {!!badge && <div className={styles.badge}>{badge}</div>}
          </div>
          <div className={styles.userInfo}>
            <div className={styles.userName}>{user.name}</div>
            {!!user.title && (
              <div className={styles.userTitle}>
                <div className={styles.oneLine}>{user.title}</div>
                <div className={styles.twoLines}>{user.title}</div>
              </div>
            )}
          </div>
        </div>
      }
      description={deltaToText(new Delta(user.description))}
      footer={
        <Tag
          icon={
            <SVGIcon size={12} className={styles.footerIcon}>
              {memberAddIcon}
            </SVGIcon>
          }
        >
          Joined <Timestamp date={user.insertedAt} />
        </Tag>
      }
      overflowMenuItems={overflowMenuItems}
      linkTo={link ? userPath(user) : undefined}
    />
  );
};

export default UserSquarishCard;
